module.exports = __webpack_public_path__ + "static/media/image 29-2.f112185b.svg";